import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { BaseService } from './base.service';

@Injectable()
export class AgencyService extends BaseService {
    constructor(protected http: Http) {
        super('agencies', http);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/services/agency.service.ts